// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "./default/chunk-article-listed.c9ceef53adb02e863914.js";
	if (chunkId === 39) return "./default/chunk-subscription.2da615057ed01fa6d120.js";
	if (chunkId === 68) return "./68.8e005a361892e6ca43c6.js";
	if (chunkId === 37) return "./default/chunk-small-gallery.eb41babbc737595917c2.js";
	if (chunkId === 33) return "./default/chunk-photo-credit-toogle.dbcce81a81813b96ea51.js";
	if (chunkId === 38) return "./default/chunk-social-click.a018574fcc2137b6228c.js";
	if (chunkId === 41) return "./default/chunk-table.68b77ea6460c9dfa21b4.js";
	if (chunkId === 45) return "./default/gallery-in-art-preserve-scroll.092d7d0896369f168ebb.js";
	if (chunkId === 69) return "./69.8e7bcc6ce2137bd0b0c7.js";
	if (chunkId === 32) return "./default/chunk-online-reports.90254ec9f60ccf3280c9.js";
	if (chunkId === 6) return "./chunk-league-table.7e65a3624568ec99ecdb.js";
	// return url for filenames based on template
	return undefined;
};